<div class="wre-table-container">
  @if (!isNoSearchResult) {
    <div #tableContainer class="table-responsive">
      <table class="table wre-table fixed-column table-hover mb-0">
        <thead class="text-center">
          <tr>
            <th class="text-nowrap column-action fixed-column">&nbsp;</th>
            <th class="text-nowrap col-ellipsis column-users">Name</th>
            @if (!isAdGroup) {
              <th class="text-nowrap col-ellipsis column-name">Email Address</th>
            }
            <th class="text-nowrap col-ellipsis column-domain text-center">App Count</th>
            <th class="text-nowrap col-ellipsis column-domain text-center">Role Count</th>
            @if (!isAdGroup) {
              <th class="text-nowrap col-ellipsis column-domain text-center">Domain</th>
            }
          </tr>
        </thead>
        <tbody class="">
          <wre-core-app-loading [isLoading]="isLoading"></wre-core-app-loading>
          @if (!isLoading) {
            @for (user of users; track user) {
              <tr>
                <td class="text-nowrap sticky-column column-action fixed-column">
                  <div class="dropdown" ngbDropdown container="body">
                    <button
                      class="btn wre-btn btn-secondary dropdown-toggle"
                      type="button"
                      ngbDropdownToggle>
                      <span>Action</span> <span class="caret"></span>
                    </button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      <button
                        class="dropdown-item"
                        routerLinkActive
                        #rla="routerLinkActive"
                        [routerLink]="[user.id, { outlets: { sidebar: 'details' } }]">
                        Details
                      </button>
                      @if (user.type === UserType.externalUser && hasEditPermission) {
                        <button
                          class="dropdown-item"
                          routerLinkActive
                          [routerLink]="[user.id, { outlets: { modal: 'edit' } }]">
                          Edit
                        </button>
                      }
                    </div>
                  </div>
                </td>
                <td class="text-nowrap col-ellipsis column-users">
                  @if (user.displayName && user.displayName.trim() === ',') {
                    <span class="ps-3">&#x2015;</span>
                  }
                  @if (user.displayName && user.displayName.trim() !== ',') {
                    <ngb-highlight [result]="user.displayName" [term]="searchTerm"></ngb-highlight>
                  }
                </td>
                @if (!isAdGroup) {
                  <td class="text-nowrap col-ellipsis column-name">
                    <ngb-highlight [result]="user.mail" [term]="searchTerm"></ngb-highlight>
                  </td>
                }
                <td class="text-nowrap col-ellipsis column-domain text-center">
                  @if (user.appCount < 10) {
                    <span>0</span>
                  }
                  {{ user.appCount }}
                </td>
                <td class="text-nowrap col-ellipsis column-domain text-center">
                  @if (user.roleCount < 10) {
                    <span>0</span>
                  }
                  {{ user.roleCount }}
                </td>
                <td class="text-nowrap col-ellipsis column-domain text-center">
                  @if (user.type === UserType.internalUser) {
                    <span class="badge bg-warning">INT</span>
                  }
                  @if (user.type === UserType.externalUser) {
                    <span class="badge bg-secondary">EXT</span>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
  @if (isNoSearchResult) {
    <div>
      <div class="no-results">
        No items were found based on your search criteria. Please try again.
      </div>
    </div>
  }
</div>
